/* eslint-disable */
export default {
  forward: 'Reenc.',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
